module.exports = __webpack_public_path__ + "img/logo.cb4b349c.png";